import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel"]

  connect() {
    this.boundCloseOnOverlay = this.closeOnOverlayClick.bind(this)
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    this.close()
    document.removeEventListener("click", this.boundCloseOnOverlay)
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  open(event) {
    event.preventDefault()
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("report-modal-open")
    document.addEventListener("click", this.boundCloseOnOverlay)
    document.addEventListener("keydown", this.boundCloseOnEscape)
  }

  close() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("report-modal-open")
    document.removeEventListener("click", this.boundCloseOnOverlay)
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  closeOnOverlayClick(event) {
    if (event.target !== this.overlayTarget) return
    this.close()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
